import React, { Component } from 'react';
import { Modal } from 'react-bootstrap'

export default class RequestFeatureModal extends Component {

  onSubmit(e) {
    e.preventDefault()
    this.props.onSubmit({
      title: this.titleInput.value.trim(),
      description: this.descriptionInput.value.trim()
    })
    this.props.onHide()
  }
  render() {
    return (
      <Modal show={this.props.show} onHide={this.props.onHide}>
        <Modal.Header closeButton>
          <Modal.Title>Request a feature</Modal.Title>
        </Modal.Header>
        <form className='form form-horizontal' onSubmit={this.onSubmit.bind(this)}>
          <Modal.Body>
            <div className='form-group'>
              <label className='control-label col-xs-2'>Title</label>
              <div className='col-xs-10'>
                <input type='text' ref={ref => this.titleInput = ref} className='form-control' required/>
              </div>
            </div>
            <div className='form-group'>
              <label className='control-label col-xs-2'>Description</label>
              <div className='col-xs-10'>
                <textarea ref={ref => this.descriptionInput = ref} className='form-control' required/>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button className='btn btn-default'>Close</button>
            <button type='submit' className='btn btn-success'>Request feature</button>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/featureboard/RequestFeatureModal.js
 **/